export { default } from './responsiveSizing'
